module.exports = __webpack_public_path__ + "img/icon-copy-clip-grey.b2934efa.svg";